<template>
  <ion-button
    class="ion-no-padding"
    fill="clear"
    @click="openInfoModal(text, image)"
  >
    Was bedeutet das?&nbsp;
    <ion-icon :icon="helpCircle" />
  </ion-button>
</template>

<script>
import { IonButton, IonIcon, modalController } from "@ionic/vue";
import InfoModal from "@lib/components/InfoModal";
import { helpCircle } from "ionicons/icons";

export default {
  components: {
    IonButton,
    IonIcon,
  },
  props: {
    text: {
      required: true,
      type: String,
    },
    image: {
      required: false,
      type: String,
      default: "",
    },
  },
  methods: {
    async openInfoModal(text, image) {
      const modal = await modalController.create({
        component: InfoModal,
        cssClass: "c-tip-modal",
        componentProps: {
          title: "Tipp",
          imagePath: image ? require("@lib/assets/img/tips/" + image) : "",
          showImage: true,
          text: text,
          closeText: "Tipp schließen",
        },
      });
      return modal.present();
    },
  },
  setup() {
    return { helpCircle };
  },
};
</script>

<style></style>
